import React, { useEffect, useState } from "react";
import DrawerTitle from "../Drawer/DrawerTitle";
import { ImageBaseUrl } from "src/lib/constans";
import { toast } from "react-toastify";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleInput from "../SimpleInput";
import GradientBtn from "../WebsiteComponents/GradientBtn";
import httpRequest from "src/helpers/httpRequest";
import FavStarIcon from "../GlobalComponents/FavStarIcon";
import {
  ICustomJwtPayload,
  isProfileCompleted,
} from "src/helpers/helperFunctions";
import { useSelector } from "react-redux";
import { RootState } from "src/Store/store";
import CartDrawer from "../AdminComponents/CartDrawer";
import EditProfileScreen from "../AllTabs/EditProfileScreen";

interface WriteReviewModalProps {
  onClose: () => void;
  onSubmit?: (data: any) => void;
  productData?: any;
  appointmentData?: any;
  type?: "product" | "appointment";
  onSuccess?: () => void;
  id?: string;
  productType?: "review" | "homeCare";
}

const WriteReviewModal = ({
  onClose,
  onSubmit,
  productData,
  appointmentData,
  onSuccess,
  id,
  productType,
}: WriteReviewModalProps) => {
  const [rating, setRating] = useState<number>(0);
  const [comment, setComment] = useState<string>("");
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [showProfileEdit, setShowProfileEdit] = useState<boolean>(false);
  const { userDetails } = useSelector((store: RootState) => store.appReducer);

  const handleSubmit = async () => {
    if (
      !isProfileCompleted(userDetails as ICustomJwtPayload, ["number"])
    ) {
      setShowProfileEdit(true);
      return;
    }
    if (rating === 0) {
      toast.error("Please select a rating");
      return;
    }
    if (comment.trim() === "") {
      toast.error("Please write a comment");
      return;
    }
    if (onSubmit) {
      onSubmit({ rating, comment });
      return;
    }
    setIsLoader(true);
    const { res, err } = await httpRequest<any>({
      method: "post",
      path: `/review/add?productType=${productType}`,
      params: {
        productId: productData?.productId,
        message: comment,
        rating: rating,
        orderId: id,
      },
    });
    if (res) {
      toast(res?.message, { type: "success" });
      onSuccess?.();
      onClose();
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="w-screen h-screen bg-black/50 fixed top-0 left-0 z-50 flex items-center justify-center">
      <div className="w-[90%] h-fit max-h-[90%] md:max-w-[36%] bg-white rounded-lg p-2 2xl:p-4">
        <DrawerTitle
          title="Review"
          backBtn
          onBack={onClose}
          shadow={false}
          innerClassName="!py-1 !px-0 border-b border-gray-200"
          // innerClassName="!p-0 !items-start border-b border-gray-200 !min-h-[35px] !2xl:min-h-[55px]"
          backBtnClassName="!-left-1.5"
          rippleEffect={false}
        />
        <div className="flex flex-col 2xl:gap-4 gap-2 pt-4">
          <div className="flex 2xl:gap-3 gap-2 ">
            <div className="w-[80px] 2xl:w-[100px] min-w-[6vw] 2xl:min-w-[6vw] aspect-square box-design flex items-center justify-center">
              <img
                src={
                  productData?.image
                    ? productData?.image
                    : productData?.productsDetails?.image
                }
                alt="product"
                className="w-[90%] h-[90%] object-contain"
              />
            </div>
            <p className="text-[#393939] font-Lexend-Regular font-size-25px line-clamp-3">
              {productData?.productName}
            </p>
          </div>
          <div className="flex flex-col gap-0.5">
            <p className="text-[#2F2F31] font-Poppins-Medium font-size-16px ">
              Rating
            </p>
            <FavStarIcon
              rating={rating}
              containerClassName="mt-2"
              setRating={setRating}
            />
          </div>
          <div className="flex flex-col">
            <SimpleInput
              value={comment}
              onChange={(val) => {
                const cleanVal = val.replace(/[^a-zA-Z0-9\s.,!?()-]/g, '');
                setComment(cleanVal);
              }}
              type="textArea"
              placeholder="Enter your Review"
              isLabel={true}
              labelText="Review"
              isRequired={false}
              extraStyle={{
                border: "1px solid #E6E6E6",
                height: "150px",
                resize: "none",
              }}
              newUi
              id="write-review-comment-input"
              isLimit={100}
              maxLength={100}
            />
          </div>
          <div className="w-full flex justify-center -mt-3">
            <GradientBtn
              onPress={handleSubmit}
              ButtonText={
                !isProfileCompleted(userDetails as ICustomJwtPayload, ["number"])
                  ? "Complete Profile to Submit"
                  : "Submit"
              }
              btnExtraStyle={{ width: "100%" }}
              loader={isLoader}
            />
          </div>
        </div>
      </div>
      <CartDrawer
        isOpen={showProfileEdit}
        onClose={() => setShowProfileEdit(false)}
      >
        <EditProfileScreen
          onBack={() => {
            setShowProfileEdit(false);
          }}
          onSuccess={() => {
            setShowProfileEdit(false);
          }}
          forceBack
        />
      </CartDrawer>
    </div>
  );
};

export default WriteReviewModal;
